<template>
  <div class="lawdetxghd">
    <sub-title text="刑法相关问答" />
    <div class="hdlist">
      <div class="hditem" v-for="item in 5" :key="item">
        <div class="tit ellipsis">故意毁坏财物罪立案后因当事人涉嫌涉嫌</div>
        <div class="bom flex_start">
          <img src="../../../assets/laws/lawdetxx.png" />
          <span>4个回复</span>
          <img src="../../../assets/laws/lawdetzan.png" />
          <span>200</span>
        </div>
      </div>
    </div>
    <div class="viewall">查看更多</div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
};
</script>

<style lang="scss" scoped>
.lawdetxghd {
  padding: 22px 12px;
  .hdlist {
    padding: 2px 14px 26px;
    font-size: 16px;
    .hditem {
      margin-top: 24px;
      color: #333333;
      cursor: pointer;
      &:hover {
        .tit {
          color: #0465ea;
        }
      }
      .bom {
        color: #999999;
        font-size: 12px;
        margin-top: 10px;
        span {
          margin-right: 28px;
        }
        img {
          margin-right: 5px;
        }
      }
    }
  }
  .viewall {
    cursor: pointer;
    width: 194px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
    background: #f1f7ff;
    border-radius: 5px;
    font-size: 18px;
    color: #0465ea;
  }
}
</style>